import {createApp} from 'vue'
import App from './App.vue'
import store from './store'
import router from "./router";
import VueGtag from "vue-gtag";
//import VueYandexMetrika from 'vue-v3-yandex-metrika'


import VueGoogleMaps from '@fawmi/vue-google-maps'

const app = createApp(App).use(router);
app.use(store);
app.use(router);
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD7-un0s7EHnFMh-yNDKC5xMi6pZE2cYEw'
    },
});
app.use(VueGtag, {
    config: {
        id: "G-VE4BN0DCHD"
    }
}, router);

app.mount('#app')
